import _values from 'lodash/values';
import _reduce from 'lodash/reduce';
import { createSelector } from 'reselect';

import RefData from 'ref-data';

// ######################################################################################## //
// INPUT SELECTORS
// ######################################################################################## //

const _scopedState = (state) => state.entities.channel;
const channelsById = (state) => _scopedState(state).byId;
const hasFetched = (state) => _scopedState(state).hasFetched;
const isFetching = (state) => _scopedState(state).isFetching;

// ######################################################################################## //
// CHANNEL SELECTORS
// ######################################################################################## //

const channels = createSelector([channelsById], (channelsById) => _values(channelsById));
const channelsByType = createSelector(
  [channels, (state, containerType) => containerType],
  (channels, containerType) => {
    return _.filter(
      channels,
      (c) => c.typeRef.id === containerType && c.status.id === RefData.Enum.STATUS.CHANNEL.ACTIVE
    );
  }
);

const channelById = createSelector([channelsById, (state, id) => id], (channelsById, id) => channelsById[id] || {});

export default {
  channels,
  hasFetched,
  isFetching,
  channelById,
  channelsByType,
};
